import { useState, useEffect } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { X } from "lucide-react";
import axios from "axios";
import { HOME } from "@/constants/testIds";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FilterBar({ filters, onChange, onClear }) {
  const [filterOptions, setFilterOptions] = useState(null);

  useEffect(() => {
    axios.get(`${API}/filters`).then(res => setFilterOptions(res.data)).catch(() => {});
  }, []);

  const hasActiveFilters = Object.values(filters).some(v => v);

  if (!filterOptions) return null;

  const renderSelect = (testId, label, optionKey, filterKey) => (
    <Select
      value={filters[filterKey] || "all"}
      onValueChange={(v) => onChange(filterKey, v === "all" ? "" : v)}
    >
      <SelectTrigger
        data-testid={testId}
        className="h-7 sm:h-8 w-auto min-w-[90px] sm:min-w-[120px] bg-transparent border-white/10 text-[11px] sm:text-xs text-white/70 hover:border-white/20 focus:ring-[#007AFF]/20 rounded-lg px-2 sm:px-3"
      >
        <SelectValue placeholder={label} />
      </SelectTrigger>
      <SelectContent className="bg-[#121214] border-white/10 text-white">
        <SelectItem value="all" className="text-xs text-white/50">{label}</SelectItem>
        {filterOptions[optionKey]?.map(opt => (
          <SelectItem key={opt.code} value={opt.code} className="text-xs">
            {opt.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );

  return (
    <div data-testid={HOME.filterBar} className="px-3 sm:px-6 py-2 sm:py-2.5 border-b border-white/5 bg-[#09090B]/80">
      <div className="max-w-[1800px] mx-auto flex items-center gap-1.5 sm:gap-2 overflow-x-auto hide-scrollbar pb-0.5">
        <span className="text-[9px] sm:text-[10px] font-mono uppercase tracking-[0.15em] text-white/25 shrink-0 mr-0.5 sm:mr-1">Filtros</span>

        {renderSelect(HOME.filterLanguage, "Idioma", "languages", "language")}
        {renderSelect(HOME.filterCountry, "País", "countries", "country")}
        {renderSelect(HOME.filterSize, "Tamanho", "image_sizes", "image_size")}
        {renderSelect(HOME.filterType, "Tipo", "image_types", "image_type")}
        {renderSelect(HOME.filterColor, "Cor", "colors", "color")}
        {renderSelect(HOME.filterTime, "Período", "time_ranges", "time_range")}

        {hasActiveFilters && (
          <button
            data-testid={HOME.clearFilters}
            onClick={onClear}
            className="flex items-center gap-1 px-2 sm:px-3 h-7 sm:h-8 text-[11px] sm:text-xs text-red-400/70 hover:text-red-400 border border-red-400/20 rounded-lg transition-colors shrink-0 cursor-pointer"
          >
            <X className="w-3 h-3" /> Limpar
          </button>
        )}
      </div>
    </div>
  );
}
